async function getProducts() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/stripe/products`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch products');
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    throw error;
  }
}

async function getProductById(id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/stripe/products/${id}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch product');
    }

    const product = await response.json();
    return product;
  } catch (error) {
    throw error;
  }
}

async function createCheckoutSession(priceId, mode, customerId) {
  try {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        priceId,
        mode,
        customerId,
      }),
    };

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/stripe/create-checkout-session`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error('Failed to create checkout session');
    }

    const session = await response.json();
    return session.sessionId;
  } catch (error) {
    throw error;
  }
}

async function getStripeTransactions(customerId) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/stripe/transactions/${customerId}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch transactions');
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    throw error;
  }
}

export {
  getProducts,
  getProductById,
  createCheckoutSession,
  getStripeTransactions,
};
